<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="总公司：">
            <el-select v-model="form.org1Id" filterable placeholder="请选择">
                <el-option
                  v-for="item in siteOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
<!--            <el-cascader
              class="search-ascader"
              v-model="form.org1Id"
                :options="siteOptions"
                :props="props"
                 placeholder="请选择"
                 filterable
                 collapse-tags
                clearable></el-cascader> -->
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart('经营指标统计')">导出</el-button>
        </el-form>
      </div>
    </div>
   <!-- <div class="chart-tile-section">
      <div class="chart-tile-item" v-for="(item, index) in tileData" :key="index">
        <div class="label">{{item.label}}</div>
        <div class="value">{{item.value}}</div>
      </div>
    </div> -->
    <div class="chart-tile-section">
      <div class="item">
        <div class="title">积分使用率=总公司消耗总积分/发放总积分</div>
        <div class="title">{{`积分使用率 = ${detail.cancelIntegral} / ${detail.getIntegral}`}}</div>
        <div class="chart-tile-item">
          <div class="label">积分使用率：</div>
          <div class="value">{{detail.integralRate}}</div>
        </div>
      </div>
      <div class="item">
        <div class="title">物业费使用率=抵扣物业总积分/发放总积分</div>
        <div class="title">{{`物业费使用率 = ${detail.wyIntegral} / ${detail.getIntegral}`}}</div>
        <div class="chart-tile-item">
          <div class="label">物业费使用率：</div>
          <div class="value">{{detail.moneyRate}}</div>
        </div>
      </div>
      <div class="item">
        <div class="title" style="color: transparent;">1</div>
        <div class="title" style="color: transparent;">1</div>
        <div class="chart-tile-item">
          <div class="label">物业总户数：</div>
          <div class="value">{{detail.house}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticalAnalysisPoints',
  data() {
    return {
      form: {
        dataTimeRange: [],
        org1Id: ''
      },
      communityOptions: [],
      props: { children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false, multiple: true },
      siteOptions: [],
      compareOptions: [],
      levelOptions: [
        { label: '总公司', value: 1 },
        { label: '分公司', value: 2 },
        { label: '项目部', value: 3 }
      ],
      tileData: [
        { label: '积分使用率：', value: 0 },
        { label: '物业费使用率', value: 0 }
      ],
      detail: {
        cancelIntegral: '',
        getIntegral: '',
        wyIntegral: ''
      }
    }
  },
  created() {
    this.orgTreeList()
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    // 初始化页面
    initPage() {
      this.siteStatistical()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          org1Id: ''
        }
      }
      this.initPage()
    },
    exportChart(name) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = '站点' + (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + '/modules/orgIntegral/integralPercentExport',
        data: this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 统计
    siteStatistical() {
      this.$api.propertyStatistics.index.integralPercent(this.form).then(res => {
        this.detail = res.data
        // this.$nextTick(() => {
        //   this.tileData[0].value = res.data.integralRate
        //   this.tileData[1].value = res.data.moneyRate
        // })
      })
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        // this.$wtUtil.setSiteLevelKey(res.data)
        this.siteOptions = res.data
        // this.$wtUtil.setTreeToList('childList', this.communityOptions, res.data)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-tile-section {
  .item {
    width: 50%;
    max-width: 460px;
    padding: 32px 0;
    font-size: 21px;
    font-weight: bold;
    & + .item {
      margin-left: 20px;
    }
    .title {
      font-size: 14px;
      text-align: center;
      margin-bottom: 10px;
    }
    .chart-tile-item {
      width: 100%;
      margin: 0;
    }
    &:nth-child(1) {
      .chart-tile-item {
        background: url('../../../assets/images/stat/bg-1.png') center no-repeat;
        background-size: 100% 100%;
      }
    }
    &:nth-child(2) {
      .chart-tile-item {
        background: url('../../../assets/images/stat/bg-2.png') center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
